import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.8333 22C10.2862 22 8.80251 21.3854 7.70854 20.2915C6.61458 19.1975 6 17.7138 6 16.1667V6.16667C6 5.0616 6.43899 4.00179 7.22039 3.22039C8.00179 2.43899 9.0616 2 10.1667 2C11.2717 2 12.3315 2.43899 13.1129 3.22039C13.8943 4.00179 14.3333 5.0616 14.3333 6.16667V16.1667C14.3333 16.8297 14.0699 17.4656 13.6011 17.9344C13.1323 18.4033 12.4964 18.6667 11.8333 18.6667C11.1703 18.6667 10.5344 18.4033 10.0656 17.9344C9.59673 17.4656 9.33333 16.8297 9.33333 16.1667V6.16667H11V16.1667C11 16.3877 11.0878 16.5996 11.2441 16.7559C11.4004 16.9122 11.6123 17 11.8333 17C12.0543 17 12.2663 16.9122 12.4226 16.7559C12.5789 16.5996 12.6667 16.3877 12.6667 16.1667V6.16667C12.6667 5.50363 12.4033 4.86774 11.9344 4.3989C11.4656 3.93006 10.8297 3.66667 10.1667 3.66667C9.50363 3.66667 8.86774 3.93006 8.3989 4.3989C7.93006 4.86774 7.66667 5.50363 7.66667 6.16667V16.1667C7.66667 17.2717 8.10565 18.3315 8.88706 19.1129C9.66846 19.8943 10.7283 20.3333 11.8333 20.3333C12.9384 20.3333 13.9982 19.8943 14.7796 19.1129C15.561 18.3315 16 17.2717 16 16.1667V6.16667H17.6667V16.1667C17.6667 17.7138 17.0521 19.1975 15.9581 20.2915C14.8642 21.3854 13.3804 22 11.8333 22Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
